import { useState, useRef } from "react";

export const OVERLAY_COMPONENTS = {
    uploadDatabase: "uploadDatabase"
};

const useOverlay = () => {
    const [isOverlayOpen, setIsOverlayOpen] = useState(false);
    const [overlayComponent, setOverlayComponent] = useState(null);
    const [openOverlayBtn, setOpenOverlayBtn] = useState(null);
    const closeOverlayBn = useRef(null);

    const toggleOverlay = (e, component) => {
        if (e?.currentTarget) setOpenOverlayBtn(e.currentTarget);

        setIsOverlayOpen(prevIsOverlayOpen => {
            if (!prevIsOverlayOpen) {
                setTimeout(() => {
                    closeOverlayBn.current.focus();
                }, 300);
            } else if (openOverlayBtn) {
                openOverlayBtn.focus();
            }
            return !prevIsOverlayOpen;
        });
        setOverlayComponent(component);
    };

    return {
        isOverlayOpen,
        overlayComponent,
        toggleOverlay,
        closeOverlayBn
    };
};

export default useOverlay;
